import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card, CardHeader, CardContent, Typography
} from '@material-ui/core';
import Chart from './Chart';
import { byLabel } from '../helpers';

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {},
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    '& > *': {
      marginLeft: theme.spacing(1)
    }
  },
  inner: {
    height: 375,
    minWidth: 500
  },
  chart: {
    height: '100%'
  }
}));

const byCount = ({ count }) => count;

function TransfersOverTime({ className, data, ...rest }) {
  const classes = useStyles();
  const dataValues = data.map(byCount);
  const dataLabels = data.map(byLabel);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        title={(
          <Typography variant="h2">
            N° de solicitudes
          </Typography>
        )}
      />
      <CardContent className={classes.content}>
        <div className={classes.inner}>
          <Chart
            className={classes.chart}
            data={dataValues}
            labels={dataLabels}
          />
        </div>
      </CardContent>
    </Card>
  );
}

TransfersOverTime.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array
};

export default TransfersOverTime;
